import { createApp } from 'vue'
import App from '@/App.vue'
import i18n from '@/plugins/i18n'
import router from '@/routes'
import VueCookies from 'vue-cookies'
import VueSmoothScroll from 'vue3-smooth-scroll'
import '@/assets/styles/tailwind.css'
import '@/pendo.js' ;


const $app = createApp(App)

$app.use(i18n)
$app.use(router)
$app.use(VueSmoothScroll)
$app.use(VueCookies);



router.isReady().then(() => {
    $app.mount('#app')
})